import { DEV_EXPERIMENT_SUFFIX } from '../common/constants/growthbook';

export function isGrowthBookFeatureAllowed(featureKey: string, allowedFeatures?: readonly string[]): boolean {
  if (!allowedFeatures) return true;

  const baseKey = featureKey.endsWith(DEV_EXPERIMENT_SUFFIX)
    ? featureKey.slice(0, -DEV_EXPERIMENT_SUFFIX.length)
    : featureKey;

  return allowedFeatures.includes(baseKey);
}
